
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, useLocation, withRouter, Routes} from "react-router-dom";

import "@arco-design/web-react/dist/css/arco.css";
import { Layout, Menu, Space, PageHeader, Carousel  } from '@arco-design/web-react';

import INDEX from './index'
import PAGE1 from './page1'
import PAGE2 from './page2'
import PAGE3 from './page3'
import PAGE4 from './page4'
import PAGE5 from './page5'
import PAGE6 from './page6'
import PAGE7 from './page7'
import ARTICLE from './article'
import CLASSROOM from './classroom'
import MUSIC_TERMS from './music_terms'

class MAIN extends Component{
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  componentDidMount(){
  }

  render() {
    let {language} = this.props
    return (<div style={{padding: 0, lineHeight: 0}}>
        <Route path="/index" exact render={(props) => <INDEX {...props} language={language} />} />
        <Route path="/" exact render={(props) => <INDEX {...props} language={language} />} />
        <Route path="/page1" exact render={(props) => <PAGE1 {...props} language={language} />} />
        <Route path="/page2" exact render={(props) => <PAGE2 {...props} language={language} />} />
        <Route path="/page3" exact render={(props) => <PAGE3 {...props} language={language} />} />
        <Route path="/page4" exact render={(props) => <PAGE4 {...props} language={language} />} />
        <Route path="/page5" exact render={(props) => <PAGE5 {...props} language={language} />} />
        <Route path="/page6" exact render={(props) => <PAGE6 {...props} language={language} />} />
        <Route path="/page7" exact render={(props) => <PAGE7 {...props} language={language} />} />
        <Route path="/page8" exact component={PAGE1}/>
        <Route path="/article" exact component={ARTICLE}/>
        <Route path="/musichall" exact component={CLASSROOM}/>
        <Route path="/music_terms" exact component={MUSIC_TERMS}/>
    </div>)
  }
}

export default withRouter(MAIN);